(() => {
  const selector = 'h1.product-title,h1.cpb-product-title';
  function init() {
    const titles = new Set();
    let frame;
    function fit(title) {
      const width = title.clientWidth;
      if (!width || !title.getClientRects().length) return;
      title.style.setProperty('white-space', 'nowrap', 'important');
      title.style.setProperty('text-wrap', 'nowrap', 'important');
      title.style.setProperty('font-size', '16px', 'important');
      const range = document.createRange();
      range.selectNodeContents(title);
      const naturalWidth = range.getBoundingClientRect().width;
      if (naturalWidth > width - 1) {
        const size = Math.floor(1600 * (width - 1) / naturalWidth) / 100;
        if (window.matchMedia('(max-width: 699px)').matches && size < 14) {
          title.style.setProperty('font-size', '14px', 'important');
          title.style.setProperty('white-space', 'normal', 'important');
          title.style.setProperty('text-wrap', 'wrap', 'important');
        } else {
          title.style.setProperty('font-size', size + 'px', 'important');
        }
      }
    }
    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        titles.forEach(title => {
          if (title.isConnected) fit(title);
          else { resize.unobserve(title); titles.delete(title); }
        });
      });
    }
    const resize = new ResizeObserver(schedule);
    window.addEventListener('resize', schedule);
    function register(root) {
      const found = root.matches?.(selector) ? [root] : [];
      found.push(...(root.querySelectorAll?.(selector) || []));
      found.forEach(title => {
        if (titles.has(title)) return;
        titles.add(title);
        resize.observe(title);
      });
      if (found.length) schedule();
    }
    register(document);
    new MutationObserver(changes => {
      changes.forEach(change => {
        if (change.type === 'characterData') {
          if (change.target.parentElement?.closest(selector)) schedule();
        } else change.addedNodes.forEach(register);
      });
    }).observe(document.body, {childList: true, subtree: true, characterData: true});
    document.fonts.ready.then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
